import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { errStatusHandler, POSTAPI } from "../../api-setup/api-helper";
import {
  REPORT_FILTER_SELECT_GRID_HISTORY,
  REPORT_FILTER_INSERT_GRID_HISTORY,
  REPORT_FILTER_UPDATE_GRID_HISTORY,
  REPORT_FILTER_DELETE_GRID_HISTORY,
  REPORT_FILTER_SELECT_OPERATORS,
  GET_SELECT_GRID_COLUMN_XML,
} from "../../api-setup/api-endpoints";
import { getUserCredential } from "../../lib/cookies";
import { GridColumnDataMapper } from "../../utils/utils";

const useReportFilterService = () => {
  const cookiesData = getUserCredential();
  const header = {
    "x-access-token": cookiesData.secretToken,
  };
  const dispatch = useDispatch();
  const history = useHistory();

  const saveReportFilter = async (data) => {
    return POSTAPI(false, REPORT_FILTER_INSERT_GRID_HISTORY, null, header, data, dispatch);
  };

  const loadReportFilters = async (data) => {
    return POSTAPI(false, REPORT_FILTER_SELECT_GRID_HISTORY, null, header, data, dispatch);
  };

  const updateReportFilter = async (data) => {
    return POSTAPI(false, REPORT_FILTER_UPDATE_GRID_HISTORY, null, header, data, dispatch);
  };

  const deleteReportFilter = async (data) => {
    return POSTAPI(false, REPORT_FILTER_DELETE_GRID_HISTORY, null, header, data, dispatch);
  };

  const selectOperators = async (data) => {
    return POSTAPI(false, REPORT_FILTER_SELECT_OPERATORS, null, header, data, dispatch);
  };

  const fetchFilterColumns = async (filterTableName, filterDbName = "procare_system") => {
    const reqData = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_filter_db_name: filterDbName,
      in_filter_table_name: filterTableName,
    };
    try {
      const res = await POSTAPI(false, GET_SELECT_GRID_COLUMN_XML, null, header, reqData, dispatch);
      const retCode = res?.data?.out_parameters?.out_ret_code;
      if (retCode === 0 || retCode === 2) {
        return GridColumnDataMapper(res.data.out_parameters.out_columns_xml) || [];
      }
      errStatusHandler(res, history, dispatch);
      return [];
    } catch (error) {
      return [];
    }
  };

  return {
    saveReportFilter,
    loadReportFilters,
    updateReportFilter,
    deleteReportFilter,
    selectOperators,
    fetchFilterColumns,
  };
};

export default useReportFilterService;
